// Module
var code = " <i title=\"{{ 'ADDITIONAL_INFORMATION' | translate }}\" aria-label=\"{{ 'ADDITIONAL_INFORMATION' | translate }}\" class=\"fa fa-info-circle\" aria-hidden=\"false\" aria-describedby=\"{{ vm.inputId }}\" id=\"{{ vm.inputId }}\" ng-if=\"!vm.isTextEmpty(vm.text)\" ng-click=\"vm.showTooltip(vm.text, $event)\"></i> ";
// Exports
module.exports = code;